module.exports = __webpack_public_path__ + "static/site-vitrine-c220f6a794984deaa8e2c2feb6b94a10.jpg";